import { render } from "./ReportsPageTableColumnId.vue?vue&type=template&id=75a984ac&ts=true"
import script from "./ReportsPageTableColumnId.vue?vue&type=script&lang=ts"
export * from "./ReportsPageTableColumnId.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__